/** Claims read off the WorkSuite access token. */
interface WorkSuiteAccessTokenClaims {
	email?: string;
	roles?: string[];
	sub: string;
}

/** Claims read off the OIDC id_token, used to fill in a friendlier display name
 * than the access token carries. */
interface OIDCIdTokenClaims {
	email?: string;
	family_name?: string;
	given_name?: string;
	name?: string;
}

/** Derive the app's `SFUser` shape from WorkSuite JWT claims. Email prefers the
 * id_token's email claim, falling back to the access token's. Name prefers
 * given_name/family_name, then falls back to splitting the id_token's `name`
 * claim, then to blank when there is no id_token at all. */
function deriveUserFromClaims(accessClaims: WorkSuiteAccessTokenClaims, idClaims: Maybe<OIDCIdTokenClaims>): SFUser {
	let firstName = "";
	let lastName = "";
	let email = accessClaims.email || "";

	if (idClaims) {
		email = idClaims.email || email;

		if (idClaims.given_name || idClaims.family_name) {
			firstName = idClaims.given_name || "";
			lastName = idClaims.family_name || "";
		} else if (idClaims.name) {
			const parts = idClaims.name.trim().split(" ");
			firstName = parts[0] || "";
			lastName = parts.slice(1).join(" ");
		}
	}

	return {
		id: accessClaims.sub,
		email,
		firstName,
		lastName,
		roles: accessClaims.roles || [],
	};
}

export default deriveUserFromClaims;
export type { WorkSuiteAccessTokenClaims, OIDCIdTokenClaims };
